import { convertToDate, configQuery, isMobileQuery, getFeatureEnabled, formatDate, toUtc, formatTime, formatCurrency, FeatureEnabledV2, getItemTime, getItemDate, formatTimeUTC, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';
import { TRANSACTIONS_NAMESPACE } from '../../store/modules/transactions/transactions.store.js';
import { store } from '../../store/index.js';
import { namespace } from 'vuex-class';
import { printContent } from '../../config/print-content.js';
import { GamingTransactionColumn } from '@gig/magic-wallet-types';
import { CoreXOperationType } from '@gig/magic-sdk/dist/adapter/users/getUserTransactionsHistory';
import { getOldestTransactionDate } from '../../utils/transactions.js';

// magic-corex-gaming-transactions
var transactions = namespace(TRANSACTIONS_NAMESPACE);
/**
 * Fetches and displays the list of gaming
 * transactions
 */
var GamingTransactionsComponent = /** @class */ (function (_super) {
    __extends(GamingTransactionsComponent, _super);
    function GamingTransactionsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Allow template to access this enum
        _this.Column = GamingTransactionColumn;
        /**
         * When enabled it will use alternative layout for the
         * payment transaction history in wallet, initially loading 30
         * items. Logic has been moved to async created() to avoid reactivity
         * issues.
         */
        _this.paymentTransactionAlternativeLayout = false;
        _this.sportsbookHistoryEnabled = false;
        /**
         * When enabled it will show the time and date
         * in local time instead of UTC.
         */
        _this.isLocalTime = false;
        /**
         * List of columns that should be displayed.
         * This property does not affect the order.
         */
        _this.columns = 'bonus-name,time,amount';
        /**
         * To show print link.
         */
        _this.showPrintGamingHistory = false;
        _this.starting = 0;
        _this.size = 0;
        _this.isMobile = false;
        _this.scrollToBottomOfGaming = function () {
            setTimeout(function () {
                var gamingElement = _this.$refs.gaming;
                gamingElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }, 50);
        };
        return _this;
    }
    Object.defineProperty(GamingTransactionsComponent.prototype, "fromDate", {
        get: function () {
            return convertToDate(this.from);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GamingTransactionsComponent.prototype, "toDate", {
        get: function () {
            return convertToDate(this.to);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GamingTransactionsComponent.prototype, "hasMoreRows", {
        get: function () {
            return this.size < this.total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GamingTransactionsComponent.prototype, "shownColumns", {
        get: function () {
            return this.columns.split(',').map(function (str) {
                return str.trim();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GamingTransactionsComponent.prototype, "shownHistory", {
        get: function () {
            var _this = this;
            var _a;
            if (this.sportsbookHistoryEnabled) {
                var allTransactions = (this.transactions || []).concat(this.sportsTransactions || []);
                allTransactions.sort(function (a, b) {
                    return new Date(b.Timestamp).getTime() -
                        new Date(a.Timestamp).getTime();
                });
                return allTransactions
                    .map(function (item) {
                    return {
                        id: item.TransactionId,
                        game: item.Payload.MediatorType ===
                            CoreXMediatorType.SPORTS
                            ? _this.getSportsEvent(item.Payload.Transaction.Current
                                .AdditionalProperties)
                            : _this.getGame(item.Payload.Transaction.Current
                                .AdditionalProperties),
                        date: new Date(item.TimestampEpoch),
                        bet: item.Payload.OperationType ===
                            CoreXOperationType.DEBIT
                            ? item.Payload.Amount
                            : 0,
                        win: item.Payload.OperationType ===
                            CoreXOperationType.CREDIT
                            ? item.Payload.Amount
                            : 0,
                        currency: item.Payload.CurrencyCode,
                        sportsDetails: item.Payload.MediatorType ===
                            CoreXMediatorType.SPORTS
                            ? _this.getSportsDetails(item.Payload.Transaction.Current
                                .AdditionalProperties)
                            : null,
                    };
                })
                    .slice(0, this.size);
            }
            return (_a = this.transactions) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                return {
                    id: item.TransactionId,
                    game: _this.getGame(item.Payload.Transaction.Current.AdditionalProperties),
                    date: new Date(item.TimestampEpoch),
                    bet: item.Payload.OperationType === CoreXOperationType.DEBIT
                        ? item.Payload.Amount
                        : 0,
                    win: item.Payload.OperationType === CoreXOperationType.CREDIT
                        ? item.Payload.Amount
                        : 0,
                    currency: item.Payload.CurrencyCode,
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    GamingTransactionsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isAlternativeLayoutFeatureEnabled, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.PAYMENT_TRANSACTION_HISTORY_ALTERNATIVE_LAYOUT)];
                    case 1:
                        isAlternativeLayoutFeatureEnabled = _b.sent();
                        if (isAlternativeLayoutFeatureEnabled) {
                            this.paymentTransactionAlternativeLayout = true;
                        }
                        // Set size after paymentTransactionAlternativeLayout is updated
                        if (this.paymentTransactionAlternativeLayout) {
                            this.size = 30;
                        }
                        else if (this.isAdvancedSearch) {
                            this.size = 10;
                        }
                        else {
                            this.size = 5;
                        }
                        _a = this;
                        return [4 /*yield*/, isMobileQuery()];
                    case 2:
                        _a.isMobile = _b.sent();
                        configQuery('wallet.gamingHistoryPrintOption', function (gamingHistoryPrintOption) {
                            _this.showPrintGamingHistory = gamingHistoryPrintOption;
                        });
                        configQuery('wallet.gamingHistoryColumns', function (gamingHistoryColumns) {
                            if (!gamingHistoryColumns) {
                                return;
                            }
                            _this.columns = gamingHistoryColumns.join(',');
                            _this.columnsValidator(_this.columns);
                        });
                        this.fetchData();
                        return [2 /*return*/];
                }
            });
        });
    };
    GamingTransactionsComponent.prototype.columnsValidator = function (columns) {
        var found = columns.split(',');
        var allValues = Object.values(GamingTransactionColumn);
        return found.every(function (column) {
            return allValues.includes(column.trim());
        });
    };
    GamingTransactionsComponent.prototype.isColumnShown = function (column) {
        return this.shownColumns.includes(column);
    };
    GamingTransactionsComponent.prototype.loadMore = function () {
        var _a, _b;
        this.isAdvancedSearch ? (this.size += 10) : (this.size += 5);
        var allTransactionsLength = (((_a = this.transactions) === null || _a === void 0 ? void 0 : _a.length) || 0) +
            (((_b = this.sportsTransactions) === null || _b === void 0 ? void 0 : _b.length) || 0);
        if (this.size > allTransactionsLength) {
            this.fetchData({
                loadMore: true,
                size: 5,
            });
        }
    };
    GamingTransactionsComponent.prototype.fetchData = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h;
        var _j = _a === void 0 ? {} : _a, _k = _j.loadMore, loadMore = _k === void 0 ? false : _k, _l = _j.size, size = _l === void 0 ? this.size : _l;
        return __awaiter(this, void 0, void 0, function () {
            var starting, fetchGaming, fetchSports, e_1;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        if (!this.from || !this.to) {
                            return [2 /*return*/];
                        }
                        _m.label = 1;
                    case 1:
                        _m.trys.push([1, 12, , 13]);
                        this.onContentLoadInit();
                        starting = loadMore
                            ? ((_b = this.transactions) === null || _b === void 0 ? void 0 : _b.length) || 0
                            : this.starting;
                        if (!this.isAdvancedSearch) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: size,
                                starting: starting,
                                mediatorType: CoreXMediatorType.CASINO,
                                displaySize: this.size,
                            })];
                    case 2:
                        _m.sent();
                        this.size = (_c = this.total) !== null && _c !== void 0 ? _c : size;
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: this.size,
                                starting: starting,
                                mediatorType: CoreXMediatorType.CASINO,
                                displaySize: this.size,
                            })];
                    case 3:
                        _m.sent();
                        if (!this.sportsbookHistoryEnabled) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.fetchSportsTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: size,
                                starting: (_e = (_d = this.sportsTransactions) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0,
                                loadMore: loadMore,
                                displaySize: this.size,
                            })];
                    case 4:
                        _m.sent();
                        this.size =
                            this.sportsTotal && this.total
                                ? this.total + this.sportsTotal
                                : size;
                        return [4 /*yield*/, this.fetchSportsTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: (_f = this.sportsTotal) !== null && _f !== void 0 ? _f : size,
                                starting: starting,
                                displaySize: this.size,
                            })];
                    case 5:
                        _m.sent();
                        _m.label = 6;
                    case 6: return [3 /*break*/, 11];
                    case 7:
                        fetchGaming = true;
                        fetchSports = true;
                        if (loadMore) {
                            fetchGaming = this.transactions.length !== this.total;
                            fetchSports =
                                this.sportsTransactions.length !== this.sportsTotal;
                        }
                        if (!fetchGaming) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: size,
                                starting: starting,
                                mediatorType: CoreXMediatorType.CASINO,
                                loadMore: loadMore,
                                displaySize: this.size,
                            })];
                    case 8:
                        _m.sent();
                        _m.label = 9;
                    case 9:
                        if (!(this.sportsbookHistoryEnabled && fetchSports)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.fetchSportsTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: size,
                                starting: (_h = (_g = this.sportsTransactions) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0,
                                loadMore: loadMore,
                                displaySize: this.size,
                            })];
                    case 10:
                        _m.sent();
                        _m.label = 11;
                    case 11:
                        this.onContentLoad(this.transactions);
                        if (loadMore) {
                            this.scrollToBottomOfGaming();
                        }
                        return [3 /*break*/, 13];
                    case 12:
                        e_1 = _m.sent();
                        this.onContentLoadError(e_1);
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    GamingTransactionsComponent.prototype.getOldestGamingTransactionDate = function () {
        if (!this.transactions || this.transactions.length === 0) {
            return;
        }
        var oldestDate = getOldestTransactionDate(this.transactions);
        this.$emit('update-from-date', oldestDate);
    };
    GamingTransactionsComponent.prototype.getGame = function (payload) {
        try {
            var parsedData = JSON.parse(payload);
            /**
             * some instances of data only included a note
             * such as 'Credited the converted free spins funds to Main wallet.'
             * which was crashing the gaming transactions history page
             */
            return parsedData.Casino ? parsedData.Casino.GameName : '-';
        }
        catch (_a) {
            return '-';
        }
    };
    GamingTransactionsComponent.prototype.getSportsEvent = function (payload) {
        var _a, _b;
        try {
            var parsedData = JSON.parse(payload);
            if ((_a = parsedData.Sports) === null || _a === void 0 ? void 0 : _a.Selections) {
                return parsedData.Sports.Selections[0].EventName;
            }
            var transactionBatchExternalId_1 = parsedData.TransactionBatchExternalId;
            var transaction = (_b = this.sportsTransactions) === null || _b === void 0 ? void 0 : _b.find(function (item) {
                var parsed = JSON.parse(item.Payload.Transaction.Current.AdditionalProperties);
                return (transactionBatchExternalId_1 ===
                    parsed.TransactionBatchExternalId &&
                    parsed.Sports.Selections);
            });
            if (transaction) {
                var parsed = JSON.parse(transaction.Payload.Transaction.Current
                    .AdditionalProperties);
                return parsed.Sports.Selections[0].EventName;
            }
            return '-';
        }
        catch (_c) {
            return '-';
        }
    };
    GamingTransactionsComponent.prototype.getSportsDetails = function (payload) {
        var parsedData = JSON.parse(payload);
        var transactionBatchExternalId = parsedData.TransactionBatchExternalId;
        var transactionStatus = parsedData.Sports.Transaction.SettlementStatus
            ? parsedData.Sports.Transaction.SettlementStatus
            : parsedData.Sports.Transaction.BetStatus;
        return { transactionBatchExternalId: transactionBatchExternalId, transactionStatus: transactionStatus };
    };
    GamingTransactionsComponent.prototype.printHistoryContent = function () {
        var rows = [];
        for (var _i = 0, _a = this.transactions; _i < _a.length; _i++) {
            var item = _a[_i];
            var currency = item.Payload.CurrencyCode;
            var bet = item.Payload.OperationType === CoreXOperationType.DEBIT
                ? item.Payload.Amount
                : 0;
            var win = item.Payload.OperationType === CoreXOperationType.CREDIT
                ? item.Payload.Amount
                : 0;
            var date = new Date(item.TimestampEpoch);
            rows.push("\n                <tr>\n                    <td>" + item.TransactionId + "</td>\n                    <td>" + this.getGame(item.Payload.Transaction.Current.AdditionalProperties) + "</td>\n                    <td>" + formatDate(toUtc(date)) + "</td>\n                    <td>" + formatTime(toUtc(date)) + "</td>\n                    <td>" + formatCurrency(bet, currency) + "</td>\n                    <td>" + formatCurrency(win, currency) + "</td>\n                </tr>\n            ");
        }
        var content = "\n            <style>\n                table { border-collapse: collapse; width: 100%; }\n                th, td { border: 1px solid black; padding: 0.25em; text-align: left; }\n                button { border: 1px solid black; color: black; font-size: 32px; margin: 0 10px; }\n                div { margin: 50px 0; text-align: center; }\n                @media print { button { display: none; } }\n            </style>\n            <table>\n                <thead>\n                    <tr>\n                        <th>" + this.$t('gaming-transactions.id.header') + "</th>\n                        <th>" + this.$t('gaming-transactions.game.header') + "</th>\n                        <th>" + this.$t('gaming-transactions.date.header') + "</th>\n                        <th>" + this.$t('gaming-transactions.time.header') + "</th>\n                        <th>" + this.$t('gaming-transactions.bet.header') + "</th>\n                        <th>" + this.$t('gaming-transactions.win.header') + "</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    " + rows.join('') + "\n                </tbody>\n            </table>\n        ";
        var buttons = "\n            <div>\n                <button onclick=\"window.print()\">" + this.$t('gaming-transactions.print') + "</button>\n                <button onclick=\"window.close()\">" + this.$t('gaming-transactions.close') + "</button>\n            </div>\n        ";
        printContent(content, buttons);
    };
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], GamingTransactionsComponent.prototype, "from", void 0);
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], GamingTransactionsComponent.prototype, "to", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], GamingTransactionsComponent.prototype, "isAdvancedSearch", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.SPORTSBOOK_HISTORY,
        }),
        __metadata("design:type", Boolean)
    ], GamingTransactionsComponent.prototype, "sportsbookHistoryEnabled", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TRANSACTIONS_HISTORY_ON_LOCAL_TIME,
        }),
        __metadata("design:type", Boolean)
    ], GamingTransactionsComponent.prototype, "isLocalTime", void 0);
    __decorate([
        transactions.Getter('isLoadingState'),
        __metadata("design:type", void 0)
    ], GamingTransactionsComponent.prototype, "isLoading", void 0);
    __decorate([
        transactions.Getter('getTransactions'),
        __metadata("design:type", void 0)
    ], GamingTransactionsComponent.prototype, "transactions", void 0);
    __decorate([
        transactions.Getter('getTransactionsTotal'),
        __metadata("design:type", void 0)
    ], GamingTransactionsComponent.prototype, "total", void 0);
    __decorate([
        transactions.Getter('getSportsTransactions'),
        __metadata("design:type", void 0)
    ], GamingTransactionsComponent.prototype, "sportsTransactions", void 0);
    __decorate([
        transactions.Getter('getSportsTransactionsTotal'),
        __metadata("design:type", void 0)
    ], GamingTransactionsComponent.prototype, "sportsTotal", void 0);
    __decorate([
        transactions.Action('fetchTransactions'),
        __metadata("design:type", Object)
    ], GamingTransactionsComponent.prototype, "fetchTransactions", void 0);
    __decorate([
        transactions.Action('fetchSportsTransactions'),
        __metadata("design:type", Object)
    ], GamingTransactionsComponent.prototype, "fetchSportsTransactions", void 0);
    __decorate([
        Watch('from'),
        Watch('to'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], GamingTransactionsComponent.prototype, "fetchData", null);
    __decorate([
        Watch('transactions', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GamingTransactionsComponent.prototype, "getOldestGamingTransactionDate", null);
    GamingTransactionsComponent = __decorate([
        Component({
            name: 'corex-gaming-transactions',
            methods: { getItemTime: getItemTime, getItemDate: getItemDate },
            store: store,
            filters: {
                formatCurrency: formatCurrency,
                toUtc: toUtc,
                formatTime: formatTime,
                formatTimeUTC: formatTimeUTC,
                formatDate: formatDate,
            },
        })
    ], GamingTransactionsComponent);
    return GamingTransactionsComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default GamingTransactionsComponent;
